/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AgentIDForm,
  AgentIDForm$Outbound,
  AgentIDForm$outboundSchema,
} from "../components/agentidform.js";

export type ResumeAgentSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ResumeAgentRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  agentIDForm: AgentIDForm;
};

/** @internal */
export type ResumeAgentSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ResumeAgentSecurity$outboundSchema: z.ZodMiniType<
  ResumeAgentSecurity$Outbound,
  ResumeAgentSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function resumeAgentSecurityToJSON(
  resumeAgentSecurity: ResumeAgentSecurity,
): string {
  return JSON.stringify(
    ResumeAgentSecurity$outboundSchema.parse(resumeAgentSecurity),
  );
}

/** @internal */
export type ResumeAgentRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  AgentIDForm: AgentIDForm$Outbound;
};

/** @internal */
export const ResumeAgentRequest$outboundSchema: z.ZodMiniType<
  ResumeAgentRequest$Outbound,
  ResumeAgentRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    agentIDForm: AgentIDForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      agentIDForm: "AgentIDForm",
    });
  }),
);

export function resumeAgentRequestToJSON(
  resumeAgentRequest: ResumeAgentRequest,
): string {
  return JSON.stringify(
    ResumeAgentRequest$outboundSchema.parse(resumeAgentRequest),
  );
}
